import React, { Component } from 'react'
import { Button, Form, Table, Input, message, Row, Col, Modal } from 'antd'
import { charteredBusList, charteredBusEdit } from '_src/api/api'
import '_src/common/style/common.less' 

const { confirm } = Modal
class List extends Component {

  constructor (props) {
    super(props)
    this.param = {
        pageNum: 0,
        pageSize: 10,
        totalElements: 0
    }
    this.state = {
        loading: true,
        dataList: [],
        status: ''
    }
  }

  componentDidMount () {
    this.loadData()
  }

  loadData () {
    this.setState({loading: true})
    const { pageNum, pageSize } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize}
    charteredBusList(param).then(res => {
        const { data } = res
        this.param.totalElements = data.totalElements
        this.setState({
            dataList: data.content,
            loading: false
          })
    })
  }

  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }

  editOrder = (record) => {
    let _self = this
    confirm({
        title: '温馨提示',
        content: (
          <p>你确定要将该订单变为已处理状态吗?</p>),
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
            _self.setState({loading: true})
            charteredBusEdit(record.id).then(res => {
                if(res.data) {
                    _self.setState({loading: false})
                    _self.loadData()
                }
            })
        },
        onCancel () {
        },
    })
  }

  columns = () => {
    return [
      {
        title: '排序',
        align: 'center',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '出发地',
        align: 'center',
        dataIndex: 'origin',
        key: 'origin',
      },
      {
        title: '途径',
        align: 'center',
        dataIndex: 'via',
        key: 'via',
      },
      {
        title: '目的地',
        align: 'center',
        dataIndex: 'destination',
        key: 'destination',
      },
      {
        title: '联系人',
        align: 'center',
        dataIndex: 'contact',
        key: 'contact',
      },
      {
        title: '联系人手机号',
        align: 'center',
        dataIndex: 'mobile',
        key: 'mobile',
      },
      {
        title: '人数',
        align: 'center',
        dataIndex: 'number',
        key: 'number',
      },
      {
        title: '创建日期',
        align: 'center',
        dataIndex: 'createAt',
        key: 'createAt',
      },
      {
        title: '用车日期',
        align: 'center',
        dataIndex: 'departAt',
        key: 'departAt',
      },
      {
        title: '订单状态',
        align: 'center',
        dataIndex: 'status',
        key: 'status',
        render: type => <span>{type === 0?'未处理':'已处理'}</span>
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
            {
                record.status === 0?<Button icon="edit" style={{marginRight: '10px'}} onClick = { () => { this.editOrder(record) } } >处理</Button>:<Button icon="edit" style={{marginRight: '10px', backgroundColor: '#F2F4F8'}} onClick = { () => {
                    message.warning('该订单已处理过!', 1.5)
                 } } >处理</Button>
            }
        </div>,
      },
    ]
  }

  handleSearch = (status) => {
    this.setState({
        status
    },() => {
        this.loadData()
    })
  }

  render () {
    const { dataList, loading, status } = this.state
    const { pageNum, totalElements } = this.param
    return (
      <div className = "Special">
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24} className = 'CharteredBus'>
                <Button className = {`filterBtn ${status === ''?'act':''}`} style={{marginRight: '20px'}} onClick={() => {
                    this.handleSearch('')
                }}>全部</Button>
                <Button className = {`filterBtn ${status === 0?'act':''}`} style={{marginRight: '20px'}} onClick={() => {
                    this.handleSearch(0)
                }}>未处理</Button>
                <Button className = {`filterBtn ${status === 1?'act':''}`} onClick={() => {
                    this.handleSearch(1)
                }}>已处理</Button>
            </Row>
          </div>
        </Form>
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
      </div>
    )
  }
}

export default List